var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.066 2H11V7C11 8.103 10.103 9 9 9H4V20C4 21.103 4.867 22 5.934 22H18.067C19.133 22 20 21.103 20 20V4C20 2.897 19.133 2 18.066 2ZM14.5 8C15.328 8 16 8.672 16 9.5C16 10.328 15.328 11 14.5 11C13.672 11 13 10.328 13 9.5C13 8.672 13.672 8 14.5 8ZM16.721 18.515C16.54 18.816 16.215 19 15.863 19H7.863C7.52 19 7.201 18.824 7.017 18.534C6.833 18.244 6.812 17.88 6.96 17.57L9.597 12.039C9.768 11.681 10.11 11.458 10.534 11.47C10.931 11.484 11.283 11.731 11.43 12.101L12.612 15.082L13.153 14.085C13.329 13.762 13.619 13.56 14.036 13.563C14.404 13.564 14.741 13.768 14.915 14.093L16.747 17.531C16.911 17.84 16.901 18.213 16.721 18.515Z",
    fill: "#6D6D77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V2.13C8.518 2.268 8.071 2.514 7.707 2.879L4.879 5.707C4.515 6.071 4.269 6.518 4.13 7H9Z",
    fill: "#6D6D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.765be4ba4f59dc4630fabb970018761c.svg";
export { ForwardRef as ReactComponent };